import { Pipe, PipeTransform } from '@angular/core';
import { TYPE_DOCUMENT } from '@constants/type-document.constants';
import { TypeDocumentEnum } from '@core/enums/type-document.enum';

@Pipe({name: 'typedocument'})
export class TypeDocumentPipe implements PipeTransform {
  transform(value: TypeDocumentEnum): string {
    return TYPE_DOCUMENT.find(x => x.id == value).descricao;
  }
}
